<script lang="ts">
  /** One collapsible section of an accordion. The parent decides which section is open. */
  import type { Snippet } from 'svelte';
  import Icon from './Icon.svelte';

  interface Props {
    id: string;
    title: string;
    open: boolean;
    /** Small text after the title (e.g. a count). */
    meta?: string;
    ontoggle: () => void;
    children: Snippet;
  }
  let { id, title, open, meta, ontoggle, children }: Props = $props();
</script>

<section class="acc" class:open data-testid={`acc-${id}`}>
  <h2>
    <button
      type="button"
      class="acc-head"
      aria-expanded={open}
      aria-controls={`acc-body-${id}`}
      data-testid={`acc-head-${id}`}
      onclick={ontoggle}
    >
      <span class="chev"><Icon name={open ? 'chevron-down' : 'chevron-right'} /></span>
      <span class="grow">{title}</span>
      {#if meta}<span class="meta">{meta}</span>{/if}
    </button>
  </h2>
  {#if open}
    <div class="acc-body" id={`acc-body-${id}`}>
      {@render children()}
    </div>
  {/if}
</section>

<style>
  .acc {
    border-bottom: 1px solid var(--border);
  }
  h2 {
    margin: 0;
    font-size: inherit;
  }
  .acc-head {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 11px 2px;
    border: none;
    border-radius: 0;
    background: none;
    text-align: left;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.01em;
  }
  .acc-head:hover {
    color: var(--accent);
  }
  .chev {
    display: inline-flex;
    color: var(--muted);
  }
  .meta {
    font-weight: 400;
    font-size: 11.5px;
    color: var(--muted);
  }
  .acc-body {
    padding: 0 2px 14px;
  }
</style>
